import React, { Component } from "react";
import ScrollContainer from 'react-indiana-drag-scroll'

class ReportTable extends Component {
  /**
   * Initializes report table state from incoming data.
   * @param {Object} props - React props including `dataSet`.
   * @return {void} No return value.
   */
  constructor(props) {
    super(props);
    this.state = {
      dataSet: this.props.dataSet,
      income: []
    }
  }


  /**
   * Lifecycle hook reserved for mount side effects.
   * @return {void} No return value.
   */
  componentDidMount() {
    // this.renderTitle();
    // this.renderTable();
    // this.renderRow();
  }

  /**
   * Builds a standalone title row from report metadata.
   * @param {Array} r - Row data containing title cell values.
   * @return {JSX.Element} Table row element.
   */
  mapTitle = (r) => {
    // console.log('r',r[0]);
    return (<tr key={r[0]}>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <th>{r[0].value}</th>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>);
  }

  /**
   * Renders one report column header cell.
   * @param {{value: string}} col - Column definition.
   * @return {JSX.Element} Header cell element.
   */
  renderColumns = (col) => {
    // console.log('col is ', col);
    return (<th key={col.value}>{col.value}</th>);
  }


  /**
   * Renders month or period headers for report sections.
   * @param {Array} columns - Header row source values.
   * @return {JSX.Element[]} Header cells for display columns.
   */
  renderTitle(columns) {
    return columns.slice(2, columns.length).map(this.renderColumns)

  }


  /**
   * Renders an individual table cell with formatting for negative or null values.
   * @param {Object|string} cell - Cell payload for display.
   * @param {number} index - Cell index in the row.
   * @return {JSX.Element} Table cell element.
   */
  renderCell = (cell, index) => {
    // console.log('cell', cell, index);
    if (typeof cell === 'string') {
      if (String(cell).startsWith('-')) {
        return <td key={index} align="left" className='red'>{cell.value}</td>
      }
      return <td key={index} align="left">{cell}</td>
    }
    else {
      if (cell.value === "Total Collection Vs Budget (%)") {
        return <td key={index} align="left">{cell.value}</td>
      }
      else if (cell.value === null) {
        return <td key={index} align="left"></td>
      }
      else if (cell.value.startsWith('-')) {
        return <td key={index} align="left" className='red'>{cell.value}</td>
      }
      else {
        return <td key={index} align="left">{cell.value}</td>
      }

    }
  }

  /**
   * Renders one report data row.
   * @param {Array} row - Row cells.
   * @param {number} index - Row index.
   * @return {JSX.Element} Table row element.
   */
  renderRow = (row, index) => {
    // console.log('row', row);
    return <tr key={index}>{row.map(this.renderCell)}</tr>
  }

  /**
   * Renders all rows for a report section.
   * @param {Array<Array>} content - Rows to render.
   * @return {JSX.Element[]} Rendered rows.
   */
  renderTable(content) {

    return content.map(this.renderRow);

  }

  /**
   * Renders staff and date metadata header row.
   * @param {Array|string} staff - Staff information block or empty string.
   * @param {Array} date - Date metadata block.
   * @return {JSX.Element} Header row for staff/date.
   */
  renderName(staff, date) {
    if (staff !== '') {
      return (<tr key={staff[0][1]}>
        <td colSpan='5'>Name: {staff[0][1]}</td>
        <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        <td></td><td className="alignright" colSpan='5'>{date[0][0]}</td>
      </tr>)
    }
    else {
      return (
        <tr>
          <td colSpan='5'></td>
          <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
          <td></td><td className="alignright" colSpan='5'>{date[0][0]}</td>
        </tr>
      )
    }

  }

  /**
   * Renders the complete report table view.
   * @param {Object} props - Component props.
   * @param {Array} props.dataSet - Structured report data sections.
   * @param {string} props.type - Report type (e.g. employee).
   * @return {JSX.Element|undefined} Report table markup when data exists.
   */
  render() {
    const dataSet = this.props.dataSet;
    const type = this.props.type;
    // console.log(dataSet);
    // console.log(type);
    var staff = '';
    console.log(dataSet)

    // var {income} = this.state;

    if (dataSet.length !== 0) {
      var title = dataSet[0].data;
      const date = dataSet[1].data;

      if (type === 'employee') {
        staff = dataSet[2].data;
        console.log(staff)
      }

      const columns = dataSet[3].data[0];
      const income = dataSet[3].data.slice(1, dataSet[3].data.length);
      const deduction = dataSet[4].data.slice(1, dataSet[4].data.length);
      const summary = dataSet[5].data;

      return (<div>
        <div className="container-fluid report">
          <div className="table-container">
            <ScrollContainer className="scroll-container">

              <form>
                <table className="table table-striped table-hover ">
                  <thead>
                    <tr className="title" key={title[0][0].value}>
                      <th colSpan='18'>{title[0][0].value}</th>
                    </tr>
                    <tr className="title" key={title[1][0].value}>
                      <th colSpan='18'>{title[1][0].value}</th>
                    </tr>
                    {this.renderName(staff, date)}
                    <tr key='months'>
                      <th colSpan='2'>MONTHS</th>
                      {this.renderTitle(columns)}
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td></td></tr>
                    {this.renderTable(income)}
                    <tr><th>Deduction</th></tr>
                    {this.renderTable(deduction)}
                    <tr><td></td></tr>
                    {this.renderTable(summary)}
                  </tbody>

                </table>
              </form>
            </ScrollContainer>

          </div>
        </div>

      </div>);

    }


  }


}

export default ReportTable;